export default "__VITE_ASSET__CYDGLM2u__"